export default __webpack_public_path__ + "static/media/thumb004.d1dc9229.png";